import {FC} from 'react';
import {Input} from "@/components/ui/Input/index";
import {Button} from "@/components/ui/Button/index";
import {Field, Form, Formik} from 'formik'
import {FormContainer, FormItem} from '@/components/ui/Form/index';
import * as Yup from 'yup'
import {CommonProps} from "@/@types/common";
import {apiCreateShred} from '@/services/ShredService';
import {ShredResponse} from "@/@types/shred";

interface StepOneProps extends CommonProps {
  onStepValidationResponse: (response: ShredResponse) => void;
  setShredName: (shredName: string) => void;
  onStepError: (error: string) => void;
  serviceId: string | undefined;
}

type CreateShredFormSchema = {
  shredName: string
}

const StepOne: FC<StepOneProps> = (props) => {
  const {
    serviceId,
    onStepValidationResponse,
    setShredName,
    onStepError,
  } = props
  
  const validationSchema = Yup.object().shape({
    shredName: Yup.string().required('Please enter the shred name'),
  })
  
  const onCreateShred = (
    values: CreateShredFormSchema,
    setSubmitting: (isSubmitting: boolean) => void
  ) => {
    const {shredName} = values
    onStepError('')
    setSubmitting(true)
    
    apiCreateShred(serviceId, {shredName: shredName})
      .then(result => {
        setShredName(shredName)
        onStepValidationResponse(result.data);
      })
      .catch(err => {
        onStepError(err?.response?.data?.body?.message || err?.response?.data?.message || "An error occurred while creating the shred")
      })
      .finally(() => {
        setSubmitting(false)
      })
  }
  
  return (
    <>
      <div className="grid grid-cols-12 gap-3">
        <div className="col-span-12">
          <Formik
            initialValues={{shredName: '',}}
            validationSchema={validationSchema}
            onSubmit={(values, {setSubmitting}) => {
              onCreateShred(values, setSubmitting)
            }}
          >
            {({touched, errors, isSubmitting}) => (
              <Form>
                <FormContainer>
                  <FormItem
                    label="Shred Name"
                    asterisk={true}
                    labelClass="text-xl text-[#6F6AF8] font-medium"
                    invalid={
                      (errors.shredName && touched.shredName) as boolean
                    }
                    htmlFor='shredName'
                    errorMessage={errors.shredName}
                  >
                    <Field
                      type="text"
                      autoComplete="off"
                      name="shredName"
                      placeholder="Enter a descriptive name for your shred (e.g., User Authentication API)"
                      component={Input}
                    />
                  </FormItem>
                  
                  <div className="mt-10 mb-4 text-right">
                    <Button
                      loading={isSubmitting}
                      variant="solid"
                      className="tracking-wider text-lg font-semibold capitalize bg-[#6F6AF8]"
                      type="submit"
                    >
                      {isSubmitting ? 'Creating Shred...' : 'Create Shred & Continue'}
                    </Button>
                  </div>
                </FormContainer>
              </Form>
            )}
          </Formik>
        </div>
      </div>
    </>
  );
};

export default StepOne;